import { ToastContentProps, toast } from "react-toastify";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

import { NotificationsType } from "@api/graphql/types-and-hooks";
import { getNotificationIcon } from "@components/NotificationsPanel/NotificationsPanel";
import { useNotificationsData } from "@providers/NotificationsProvider";
import { getNotificationLink } from "@providers/notificationNavigation";

interface NotificationToastProps {
  notification: NotificationsType;
}

const NotificationToast: React.FC<NotificationToastProps & ToastContentProps> = ({ notification, closeToast }) => {
  const { readNotification } = useNotificationsData();

  const notificationOnClick = async (notification: NotificationsType) => {
    const path = await readNotification(notification);

    if (path) {
      // we can't use navigate here, since the toast is outside of the router context
      window.location.href = path;
    }

    closeToast();
  };

  const link = getNotificationLink(notification);

  return (
    <div
      className="flex flex-row gap-2 w-full cursor-pointer"
      onClick={() => {
        notificationOnClick(notification);
      }}
    >
      <div className="flex flex-col">{getNotificationIcon(notification.notificationType)}</div>
      <div className="flex flex-col gap-1">
        <Paragraph displayType="loud" colorType="primary" size="small" className="ph-no-capture">
          {notification.title}
        </Paragraph>
        <Paragraph colorType="primary" size="small" className="ph-no-capture">
          {notification.description}
        </Paragraph>
        {link && (
          <Paragraph displayType="loud" size="small" className="text-dynamic-text-primary-default underline">
            {link}
          </Paragraph>
        )}
      </div>
    </div>
  );
};

export const newNotification = (notification: NotificationsType) =>
  toast((props) => <NotificationToast {...props} notification={notification} />, {
    closeButton: true,
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    style: {
      marginTop: "40px",
    },
  });
